import Vue from 'vue';

/**
 * This file enables the automatic initialization
 * of module Javascript based on the prevalence of
 * data-module="" attributes in the DOM. You should not
 * really need to interact with this file. It is
 * included once in main.js only.
 */
class Init {
  constructor() {
    this.modules = [];
    this.init = this.init.bind(this);
  }

  async init() {
    const uniq = (value, index, self) => self.indexOf(value) === index;
    const sections = document.querySelectorAll('[data-module]');
    const sectionNames = [...sections]
      .map((section) => section.dataset.module)
      .filter(uniq);

    const vueBaseComponents = document.querySelectorAll('[base-component]');
    const vueBaseComponentNames = [...vueBaseComponents]
      .map((section) => section.getAttribute('base-component'))
      .filter(uniq);

    // Initialize modules that use data-module="module-name" syntax
    sectionNames.forEach(async (name) => {
      const m = await import(
        /* webpackChunkName: "[index]" */ `../../../modules/${name}/${name}.js`
      );
      const module = m.default;
      const modules = [...sections].filter(
        (section) => section.dataset.module === name,
      );

      modules.forEach((element) => {
        if (Boolean(module)) {
          module(element);
        }
      });
    });

    // Initialize Vue components that use base-component="component-name" syntax
    // This registers the Vue component globally
    // Only commonly reused components should be registered this way
    vueBaseComponentNames.forEach(async (name) => {
      const m = await import(
        /* webpackChunkName: "[index]" */ `../../../modules/${name}/${name}.vue.js`
      );
      Vue.component(name, m.default || m);
    });
  }
}

export default new Init();
